import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
import Breadcrumbs from '../Components/banner/New-banner';
import Allcategories from '../Components/Categories/Allcategories';

const Categoriepage = () => {
    return (
        <>
            <Combaintop />
            <Breadcrumbs />
            <Allcategories/>
            <Combainbottom />
        </>
    )
}

export default Categoriepage
